export const CONTACT = {
  phoneDisplay: "306 942 7345",
  phoneHref: "tel:+13069427345",
  email: "info@serfixservice.com",
  mailHref: "mailto:info@serfixservice.com",
  location: "Regina, Saskatchewan",
};

export const BRAND_IMAGES = {
  logoPoster:
    "https://customer-assets.emergentagent.com/job_firm-preview-2/artifacts/uwebhib0_image.png",
  servicePoster:
    "https://customer-assets.emergentagent.com/job_firm-preview-2/artifacts/leu6vkmp_image.png",
  tools:
    "https://images.unsplash.com/photo-1623161551727-54c918bdcec1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  regina:
    "https://images.unsplash.com/photo-1636594107332-c57936a1f03e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "appliance",
    title: "Appliance repair & installation",
    short: "Install, troubleshoot, and repair essential home appliances.",
    detail: "For washers, dryers, dishwashers, small fixtures, and everyday household repairs.",
  },
  {
    id: "drywall",
    title: "Drywall & painting",
    short: "Clean patches, surface prep, and sharp paint finishes.",
    detail: "Ideal for move-in refreshes, damaged walls, and practical room updates.",
  },
  {
    id: "doors",
    title: "Doors, trim & fixtures",
    short: "Adjustments, replacements, hardware, trim, and finishing work.",
    detail: "Small carpentry fixes that make your space look finished and work properly.",
  },
  {
    id: "maintenance",
    title: "General maintenance",
    short: "Reliable handyman help for the jobs that keep piling up.",
    detail: "From repairs to punch-list tasks for homes, rentals, and small businesses.",
  },
];

export const BENEFITS = [
  "Quality workmanship",
  "On time & on budget",
  "Affordable pricing",
  "Friendly, local service",
];

export const NAV_ITEMS = [
  { label: "Services", href: "#services", testId: "header-nav-services-link" },
  { label: "Why SERFIX", href: "#about", testId: "header-nav-about-link" },
  { label: "Contact", href: "#contact", testId: "header-nav-contact-link" },
];